import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PortalPage, Card, LogoBox, Subtitle, Field, Msg, SubmitBtn, Footer,
} from './corretorPortalStyles';
import { setCorretorPassword } from '../services/corretorAuthService';
import { supabase } from '../../../services/supabaseClient';
import { MF_BASE } from '../basePath';

// Pagina destino do link de invite (ou recovery) que o Supabase manda por email.
// O Supabase JS detecta o token na URL (#access_token=...&type=invite|recovery)
// e cria sessao temporaria que permite chamar updateUser({ password }).
export default function CorretorSetPasswordPage() {
  const navigate = useNavigate();
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [sessionOk, setSessionOk] = useState(null); // null = loading, true | false
  const [done, setDone] = useState(false);

  useEffect(() => {
    // Aguarda Supabase processar o hash da URL (detectSessionInUrl default = true)
    let cancelled = false;
    const check = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (cancelled) return;
      setSessionOk(!!session);
    };
    check();
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY' || event === 'SIGNED_IN') check();
    });
    return () => { cancelled = true; sub.subscription?.unsubscribe(); };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (pass.length < 8) { setError('Senha deve ter pelo menos 8 caracteres.'); return; }
    if (pass !== pass2) { setError('As senhas não coincidem.'); return; }
    setBusy(true);
    const res = await setCorretorPassword(pass);
    setBusy(false);
    if (!res.ok) { setError(res.error || 'Erro ao definir senha.'); return; }
    setDone(true);
    // Limpa hash da URL e redireciona pro login apos pequena pausa
    if (typeof window !== 'undefined') {
      window.history.replaceState(null, '', window.location.pathname);
    }
    await supabase.auth.signOut();
    setTimeout(() => navigate(`${MF_BASE}/corretor/login`, { replace: true }), 2000);
  };

  return (
    <PortalPage>
      <Card onSubmit={handleSubmit}>
        <LogoBox>
          <img src="/mf-real-state/logos/mf-logo-dark.png" alt="MF Real Estate" />
        </LogoBox>
        <Subtitle>Definir senha de acesso</Subtitle>

        {sessionOk === null && <Msg>Carregando...</Msg>}

        {sessionOk === false && (
          <Msg>
            Link inválido ou expirado. Solicite um novo link de acesso pela tela de login.
          </Msg>
        )}

        {sessionOk && !done && (
          <>
            <Field>
              Nova senha
              <input
                type="password" autoComplete="new-password"
                value={pass} onChange={e => { setPass(e.target.value); setError(''); }}
                disabled={busy} autoFocus
              />
            </Field>
            <Field>
              Confirmar senha
              <input
                type="password" autoComplete="new-password"
                value={pass2} onChange={e => { setPass2(e.target.value); setError(''); }}
                disabled={busy}
              />
            </Field>

            {error && <Msg>{error}</Msg>}

            <SubmitBtn type="submit" disabled={busy}>
              {busy ? 'Salvando...' : 'Salvar e entrar'}
            </SubmitBtn>
          </>
        )}

        {done && (
          <Msg $ok>
            Senha definida! Redirecionando para o login...
          </Msg>
        )}

        <Footer>MF Real Estate · Corretores</Footer>
      </Card>
    </PortalPage>
  );
}
